var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatMap12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 81,
    viewBox: "0 0 107 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67,
    filter: "url(#filter0_f_1693_26283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0637 5.83049C35.0658 5.57709 34.0665 5.36911 33.0672 5.20386C-1.41902 -0.498877 -7.54629 50.8851 23.5014 66.9431C36.3688 73.5981 51.39 78 68.0362 78C110.666 78 98.2324 70.7809 103.561 27.4806C108.89 -15.8198 64.4837 13.0472 36.0637 5.83049Z",
    fill: "url(#paint0_linear_1693_26283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0637 5.83049C35.0658 5.57709 34.0665 5.36911 33.0672 5.20386C-1.41902 -0.498877 -7.54629 50.8851 23.5014 66.9431C36.3688 73.5981 51.39 78 68.0362 78C110.666 78 98.2324 70.7809 103.561 27.4806C108.89 -15.8198 64.4837 13.0472 36.0637 5.83049Z",
    stroke: "#52CB74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1693_26283",
    x: 0.859375,
    y: 0.5,
    width: 105.641,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1693_26283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1693_26283",
    x1: 14.7487,
    y1: 25.679,
    x2: 111.652,
    y2: 92.8147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E13827"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap12);
export default __webpack_public_path__ + "static/media/heatMap12.6640c1206573bcdb44ee7e0868fb0269.svg";
export { ForwardRef as ReactComponent };